const SIZES = { hero: "wm-hero", page: "wm-page", header: "wm-header" };
const SIGN = { hero: "text-2xl sm:text-4xl", page: "text-2xl", header: "wm-sign-header text-[clamp(13px,4vw,18px)]" };

// Brand wordmark: always one line, fluid to its container width; brand stays LTR in RTL locales.
export const Wordmark = ({ size = "page", signature = true, testId = "brand-wordmark", className = "" }) => {
  const fluid = size !== "header";
  const layout = size === "hero" ? "flex flex-col items-start gap-1" : `${fluid ? "flex" : "inline-flex"} flex-wrap items-end gap-x-3 gap-y-1`;
  return (
    <div dir="ltr" className={`${fluid ? "wm-box" : ""} ${layout} ${className}`} data-testid={testId}>
      <span className={`wordmark ${SIZES[size]}`} aria-label="FAB-MIND-OS">
        <span className="wm-part wm-fab">FAB-MIND</span>
        <span className="wm-part wm-os">-OS</span>
      </span>
      {signature && (
        <span className={`font-sign gold-text leading-none ${SIGN[size]}`} data-testid={`${testId}-signature`}>
          by Fabrice
        </span>
      )}
    </div>
  );
};
